import queryString from "query-string";
import { LinkedAccountsFilters } from "../hooks/useLinkedAccountsFilters";

interface Params {
  filters: LinkedAccountsFilters;
  isTestAccounts: boolean;
  completeProductionDuplicatesOf?: string | null;
}

export const buildLinkedAccountsParams = ({
  filters,
  isTestAccounts,
  completeProductionDuplicatesOf,
}: Params): string =>
  queryString.stringify({
    ...(isTestAccounts ? { is_test_account: true } : {}),
    ...(filters.search ? { search: filters.search } : {}),
    ...(filters.integrationName ? { integration__name: filters.integrationName } : {}),
    ...(filters.status ? { status: filters.status } : {}),
    ...(filters.category ? { category: filters.category } : {}),
    ...(completeProductionDuplicatesOf
      ? { complete_production_duplicates_of: completeProductionDuplicatesOf }
      : {}),
  });
